import { Vector3 } from 'three';

import { DragControlsModifier } from '../types.js';

const getPredominantAxisVector = (
  initialPosition: Vector3,
  newPosition: Vector3,
  threshold = 0.1
) => {
  const displacement = newPosition.clone().sub(initialPosition);
  const axisVector = new Vector3();

  let predominantAxisIndex = -1;
  let maxComponent = -1;

  displacement.toArray().forEach((component, index) => {
    if (Math.abs(component) > threshold && Math.abs(component) > maxComponent) {
      predominantAxisIndex = index;
      maxComponent = Math.abs(component);
    }
  });

  if (predominantAxisIndex !== -1) {
    axisVector.setComponent(predominantAxisIndex, 1);
    return axisVector;
  }

  return axisVector;
};

export const restrictToAlignedAxis: DragControlsModifier = (state) => {
  const { initial, position } = state;
  const axis = getPredominantAxisVector(initial, position);
  const alignedPosition = initial.clone().add(position.clone().sub(initial).multiply(axis));
  position.copy(alignedPosition);

  return {
    ...state,
    position,
  };
};
